import gsap from 'gsap';
import { trace } from 'rytm-helpers';
import { classNames } from '../constants';

export const initImageZoom = () => {
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('hide.bs.offcanvas', closeZoom);
}

export const closeZoom = () => {  
  const links = [...document.querySelectorAll(`.${classNames.IMAGE_LINK_ZOOMED}[data-zoom-toggle]`)];
  links.forEach(closeZoomLink)
}
const closeZoomLink = (link) => {
  link.classList.remove(classNames.IMAGE_LINK_ZOOMED);
  const selector = link.dataset.zoomToggle;
  const wrapper = document.documentElement.querySelector(selector);
  if (!wrapper) {
    console.warn('Image zoom wrapper not found');
    closeZoomAnimationCompleted();
    return false;
  }
  const img = wrapper.querySelector('img');
  if (!img) {
    closeZoomAnimationCompleted();
    console.warn('Image not found in wrapper');
    return false;
  }
  // get initial rect from data attribute
  const initialRect = JSON.parse(img.getAttribute('data-initial-rect'));
  // animate back to initial position and size
  img.style.position = 'absolute';
  gsap.to(img, {
    top: initialRect.top,
    left: initialRect.left,
    width: initialRect.width,
    height: initialRect.height,
    duration: 0.25,
    ease: 'power3.out',
    onComplete: () => {
      img.remove();
      closeZoomAnimationCompleted();
    }
  });
}
const closeZoomAnimationCompleted = () => {
  
  document.documentElement.classList.remove(classNames.IMAGE_ZOOM_ON);
}

const onDocumentClick = (e) => {
  const link = e.target.closest('a');
  if (link) {
    if (link.hasAttribute('data-zoom-toggle')) {
      e.preventDefault();
      toggleZoom(link);
    } else if (link.hasAttribute('data-zoom-close')) {
      e.preventDefault();
      closeZoom();
    } else if (link.classList.contains('zoomed-image-wrapper')) {
      e.preventDefault();
      closeZoom();
    }
  }
}

const toggleZoom = (link) => {
  if (!link.classList.contains(classNames.IMAGE_LINK_ZOOMED)) {
    openZoom(link);
  }
}

const openZoom = (link) => {
  const selector = link.dataset.zoomToggle;
  const wrapper = document.documentElement.querySelector(selector);
  // console.log("wrapper", wrapper)
  if (!wrapper) {
    console.warn('Image zoom wrapper not found');
    return false;
  }
  const linkImg = link.querySelector('img');
  if (!linkImg) {
    console.warn('Image not found in link');
    return false;
  }
  const initialRect = linkImg.getBoundingClientRect();
  const img = document.createElement('img');
  img.src = linkImg.src;
  img.alt = linkImg.alt;
  // set initial position and size as the clicked image
  img.style.position = 'absolute';
  img.style.top = `${initialRect.top}px`;
  img.style.left = `${initialRect.left}px`;
  img.style.width = `${initialRect.width}px`;
  // img.style.height = `${initialRect.height}px`;
  // save initial rect as data attribute
  img.setAttribute('data-initial-rect', JSON.stringify(initialRect));
  wrapper.appendChild(img);
  // animate to full width
  gsap.to(img, {
    top: 0,
    left: 0,
    width: '100%',
    // height: 'auto',
    duration: 0.5,
    ease: 'power2.out',
    onComplete: () => {
      img.style.position = 'static';
    }
  });
  link.classList.add(classNames.IMAGE_LINK_ZOOMED);
  document.documentElement.classList.add(classNames.IMAGE_ZOOM_ON);


}